import {
  AppWindowIcon,
  ArrowsLeftRightIcon,
  ChartBarIcon,
  GridNineIcon,
  DatabaseIcon,
  FileXlsIcon,
  SigmaIcon,
  TrayArrowDownIcon,
  TableIcon,
  type Icon,
  type IconProps,
  type IconWeight,
} from '@phosphor-icons/react';
import { cn } from '@/lib/utils';
import type { WorkbookItemIconKind } from './workbookItemIconKind';

const icons: Record<
  WorkbookItemIconKind,
  { icon: Icon; weight?: IconWeight; className?: string }
> = {
  xlsx: {
    icon: FileXlsIcon,
    weight: 'fill',
    className: 'text-xlsx',
  },
  data: { icon: DatabaseIcon },
  // A mapping turns one value into another.
  mapping: { icon: ArrowsLeftRightIcon },
  worksheet: { icon: TableIcon },
  pivot: { icon: SigmaIcon },
  freeform: { icon: GridNineIcon },
  report: { icon: ChartBarIcon },
  sink: { icon: TrayArrowDownIcon },
  app: { icon: AppWindowIcon },
};

/**
 * An Item's icon. Excel Items render filled in the Excel green; the others
 * inherit the surrounding text color unless `className` sets one.
 */
export function WorkbookItemIcon({
  kind,
  className,
  ...props
}: { kind: WorkbookItemIconKind } & Omit<IconProps, 'weight'>) {
  const { icon: ItemIcon, weight, className: kindClassName } = icons[kind];
  return (
    <ItemIcon
      weight={weight}
      data-workbook-item-icon={kind}
      className={cn(className, kindClassName)}
      {...props}
    />
  );
}
